import styled from "styled-components";
import { backgroundColor, primaryColor, secondaryColor, tertiaryColor } from "../../../../styles/variables";

interface BannerProps {
    image: string,
    text: string
}
export default function Banner({image, text}: BannerProps) {
    const BannerContainer = styled.article`
      position: relative;
      color: ${primaryColor};
      img {
        width: 100vw;
        height: 50vh;
      }
      h3 {
        
        position: absolute;
        top: 10%;
        text-align: center;
        font-size: 2rem;
        font-weight: bold;
        text-shadow: 2px 2px 0px black;
      }

    @media only screen and (min-width: 700px){
      img {
        object-fit: cover;
      }
}
    `;

    return (
        <>
               <BannerContainer>
                <img src={image} alt="banner" />
                <h3>{text}</h3>
              </BannerContainer>
        </>
    );

}